// Rota raiz "/" (sem slug): o cardápio é sempre acessado por
// cardapio.vittogestao.com.br/<slug>. Sem slug não há o que mostrar — página
// amigável, sem erro cru.
export function LandingState() {
  // Item 48: a página inteira é a região principal e o título é de nível 1.
  return (
    <main className="estado-pagina">
    <div className="state" role="status">
      <div className="emoji" aria-hidden="true">
        📱
      </div>
      <h1>Escaneie o QR da mesa</h1>
      <p>
        Este é o cardápio digital do Vitto. Aponte a câmera para o QR Code do estabelecimento para
        abrir o cardápio dele.
      </p>
    </div>
    </main>
  );
}
